import attributionSdk from 'getu-attribution-v2-sdk'
import { AppConfigService } from '../config'

export class GetuAttributionService {
  private static initialized = false
  private static initializing: Promise<void> | null = null

  static async initOnce(options?: { userId?: string | null }): Promise<void> {
    if (import.meta.env.DEV) {
      console.log('🔕 Attribution disabled in development mode')
      return
    }

    if (this.initialized) return
    if (this.initializing) return this.initializing

    this.initializing = this.doInit(options)
    return this.initializing
  }

  private static async doInit(options?: { userId?: string | null }): Promise<void> {
    const { apiKey, apiEndpoint } = this.readConfig()
    if (!apiKey) {
      console.log('🔕 Attribution disabled: VITE_PUBLIC_ATTRIBUTION_API_KEY is not set')
      return
    }

    try {
      await attributionSdk.init({
        apiKey,
        apiEndpoint: apiEndpoint || undefined,
        autoTrack: true,
        autoTrackPageView: true,
        userId: options?.userId || undefined,
      })
      this.initialized = true
      console.log('✅ GetuAttribution initialized')
    } catch (error) {
      console.warn('⚠️ Failed to initialize GetuAttribution:', error)
    }
  }

  static setUserIdBestEffort(userId: string | null | undefined): void {
    if (!this.initialized || !userId) return
    try {
      attributionSdk.setUserId(userId)
    } catch (error) {
      console.warn('⚠️ Failed to set attribution userId:', error)
    }
  }

  static trackLoginBestEffort(userId: string | null | undefined, payload?: { email?: string }): void {
    if (!this.initialized || !userId) return
    try {
      attributionSdk.trackLogin(userId, payload || {})
    } catch (error) {
      console.warn('⚠️ Failed to track attribution login:', error)
    }
  }

  private static readConfig(): { apiKey: string; apiEndpoint: string } {
    return {
      apiKey: String(AppConfigService.getString('VITE_PUBLIC_ATTRIBUTION_API_KEY') ?? '').trim(),
      apiEndpoint: String(AppConfigService.getString('VITE_PUBLIC_ATTRIBUTION_API_ENDPOINT') ?? '').trim(),
    }
  }
}
